exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#submit-button\n{\n    padding: 8px;\n    text-align: center;\n    border-radius: 3px;\n    margin: 20px 0px;\n}\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/ocr/ocr-document-uploader/ocr-document-uploader.component.css
// module id = ../../../../../src/app/ocr/ocr-document-uploader/ocr-document-uploader.component.css
// module chunks = 0